import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import BaseButton from "../../components/button/BaseButton";
import {FormattedMessage} from "react-intl";
import AvatarIcon from "../../components/AvatarIcon";
import Close from "react-icons/lib/io/close";

@observer
class VideoAskToJoin extends Component {

    render() {
        const {student, onDecline, onAccept, full = true} = this.props;
        if (!student) {
            return null;
        }
        return (
            <div className="remote remote-waiting">
                <div className={"video-request"}>
                    <button className="video-chat-close" onClick={onDecline}>
                        <Close/>
                    </button>
                    {full && <AvatarIcon iconStyle={{width: 66, height: 66}} icon={student.avatar} fullName={student.name} useDefault={false}/>}
                    <div className={"video-text"}>{student.name} <FormattedMessage id={'video.chat.student.request'}/></div>
                    <div className={"video-request-buttons"}>
                        <BaseButton className="decline-button" onClick={onDecline}
                                    label={<FormattedMessage id={'video.chat.deny'}/>}/>
                        <BaseButton className="accept-button" onClick={onAccept}
                                    label={<FormattedMessage id={'video.chat.approve'}/>}/>
                    </div>
                </div>
            </div>
        );

    }
}

export default VideoAskToJoin;
